module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [(_vm.$store.state.user.scope.has_email_sent === false && !_vm.hasSent) ? _c('alert', {
    attrs: {
      "type": "warning",
      "icon": "warning",
      "align": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Please confirm your account by email!\n        "), _c('br'), _vm._v(" "), (!_vm.isSending) ? _c('a', {
    staticClass: "pointer",
    attrs: {
      "slot": "action",
      "href": "#"
    },
    domProps: {
      "textContent": _vm._s(_vm.$store.state.user.scope.has_email_sent ? 'Resend email' : 'Send email')
    },
    on: {
      "click": _vm.sendConfirmationEmail
    },
    slot: "action"
  }) : _vm._e(), _vm._v(" "), (_vm.isSending) ? _c('a', {
    staticClass: "pointer",
    attrs: {
      "slot": "action",
      "href": "#",
      "disabled": _vm.isSending
    },
    domProps: {
      "textContent": _vm._s(_vm.isSending ? 'Sending...' : 'Done!')
    },
    on: {
      "click": _vm.sendConfirmationEmail
    },
    slot: "action"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.scope.has_email_sent && !_vm.hasSent) ? _c('alert', {
    attrs: {
      "type": "success",
      "icon": "check",
      "align": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n        You have already been sent an account activation email. Please check your email inbox to find it (have a look in\n        the spam folder too, just in case it was sorted into there by mistake!)\n        "), _c('br'), _vm._v(" "), (!_vm.isSending) ? _c('a', {
    staticClass: "pointer",
    attrs: {
      "slot": "action",
      "href": "#"
    },
    domProps: {
      "textContent": _vm._s(_vm.$store.state.user.scope.has_email_sent ? 'Resend email' : 'Send email')
    },
    on: {
      "click": _vm.sendConfirmationEmail
    },
    slot: "action"
  }) : _vm._e(), _vm._v(" "), (_vm.isSending) ? _c('a', {
    staticClass: "pointer",
    attrs: {
      "slot": "action",
      "href": "#",
      "disabled": _vm.isSending
    },
    domProps: {
      "textContent": _vm._s(_vm.isSending ? 'Sending...' : 'Done!')
    },
    on: {
      "click": _vm.sendConfirmationEmail
    },
    slot: "action"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.hasSent) ? _c('alert', {
    attrs: {
      "type": "success",
      "icon": "check",
      "align": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n        Please check your email inbox for an account activation email. If you cannot find it, please check your spam\n        folder in case it was sorted into there by mistake!\n        "), _c('br'), _vm._v(" "), (!_vm.isSending) ? _c('a', {
    staticClass: "pointer",
    attrs: {
      "slot": "action",
      "href": "#"
    },
    domProps: {
      "textContent": _vm._s(_vm.$store.state.user.scope.has_email_sent ? 'Resend email' : 'Send email')
    },
    on: {
      "click": _vm.sendConfirmationEmail
    },
    slot: "action"
  }) : _vm._e(), _vm._v(" "), (_vm.isSending) ? _c('a', {
    staticClass: "pointer",
    attrs: {
      "slot": "action",
      "href": "#",
      "disabled": _vm.isSending
    },
    domProps: {
      "textContent": _vm._s(_vm.isSending ? 'Sending...' : 'Done!')
    },
    on: {
      "click": _vm.sendConfirmationEmail
    },
    slot: "action"
  }) : _vm._e()])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-528c92ad","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmailVerification/EmailVerification.vue
// module id = 3725
// module chunks = 1